import { AfterViewInit, Directive, ElementRef, Input, inject } from '@angular/core';
import { LocaleService, ReactiveDirective } from '@any2any/shared';
import { PageTitleService } from '../services/page-title.service';

@Directive({
  selector: '[appPageTitle]',
  standalone: true
})
export class PageTitleDirective extends ReactiveDirective implements AfterViewInit {

  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly pageTitleService = inject(PageTitleService);
  private readonly localeService = inject(LocaleService);

  private setTitle?: string;
  private contentBound?: boolean;

  @Input()
  public set appPageTitle(title: string) {
    if (this.contentBound) {
      return;
    }
    this.setTitle = title;
    this.pageTitleService.title = title;
  }

  public ngAfterViewInit(): void {
    if (this.setTitle) {
      return;
    }
    this.contentBound = true;
    this.readTitleFromNodeContent();
    // Each time the language changes, we need to re-read node's text content.
    this.localeService.onLanguage()
      .pipe(
        this.observeAsync(),
        this.observeUntilDestroy()
      )
      .subscribe(() => {
        this.readTitleFromNodeContent();
      });
  }

  private readTitleFromNodeContent(): void {
    const firstNode = this.elementRef.nativeElement.childNodes.item(0);
    if (firstNode?.nodeType === firstNode.TEXT_NODE) {
      const text = firstNode.textContent?.trim();
      if ((text?.length ?? 0) > 0) {
        this.pageTitleService.title = text;
      }
    }
  }
}
